import { URL_ROOT } from '@seek/adv-constants';
import { useTranslations } from '@vocab/react';
import { AccordionItem, Stack, Text, TextLink } from 'braid-design-system';
import type React from 'react';

import { FAQ_PRESSED } from 'src/app/shared/dataAnalytics/schema/constants';
import getTrackingAdapter from 'src/app/v1/dataAnalytics';
import { useLocalisedRoutes } from 'src/app/v1/views/hooks/useLocalisedRoutes';

import translations from './.vocab';

export const Faqs = () => {
  const { t } = useTranslations(translations);

  const { localiseRoute } = useLocalisedRoutes();

  const onToggle = (expanded: boolean, selectedQuestion: string) => {
    if (expanded) {
      const formattedSelectedQuestion = selectedQuestion.replace(/\s/g, '-'); // replace whitespaces with -

      const EVENT_NAME_FAQ_EXPANDED = 'faq-expanded';

      const eventData = {
        eventName: FAQ_PRESSED,
        objectInteraction: `${EVENT_NAME_FAQ_EXPANDED}[${formattedSelectedQuestion}]`,
      };
      getTrackingAdapter.sendLinkEvent(eventData);
    }
  };

  const params = {
    Link: (children: React.ReactNode[]) => (
      <TextLink
        href={localiseRoute(URL_ROOT)}
        rel="noopener noreferrer"
        target="_blank"
      >
        {children}
      </TextLink>
    ),
  };

  const faqs = [
    {
      title: t('faqs-q1'),
      content: t('faqs-a1'),
    },
    {
      title: t('faqs-q2'),
      content: t('faqs-a2', params),
    },
    {
      title: t('faqs-q3'),
      content: t('faqs-a3'),
    },
    {
      title: t('faqs-q4'),
      content: t('faqs-a4', params),
    },
    {
      title: t('faqs-q5'),
      content: t('faqs-a5', params),
    },
  ];

  return (
    <Stack space="xlarge">
      {faqs.map(({ title, content }) => (
        <AccordionItem
          id={title}
          key={title}
          label={title}
          onToggle={(expanded) => onToggle(expanded, title)}
        >
          <Text tone="secondary">{content}</Text>
        </AccordionItem>
      ))}
    </Stack>
  );
};
